import { Factory } from 'rosie';
import '../conversation_item_factory';

Factory.define('AIFunctionCall')
  .attr('type', 'AI_FUNCTION_CALL');

Factory.define('AIFunctionCallWithDefaults')
  .extend('AIFunctionCall')
  .attr('guideId', 'default-guide-id')
  .attr('guideType', 'TRANSACTION_GUIDE')
  .attr('calls', [
    {
        id: 'call-1',
        name: 'guide-name',
        arguments: {
            keywords: 'mock-keywords',
        }
    }
  ])
  .attr('results', {
    id: 'call-1',
    output: 'mock-output',
  });


Factory.define('AIFunctionCallItemWithDefaults')
  .extend('ConversationItem')
  .attr('content', ['content'], content => Factory.attributes('AIFunctionCallWithDefaults', content))
  .attr('initiator', {
    type: 'SYSTEM',
    id: 'SIDEKICK_V2',
  });
